import api_voitto from "../../services/apivoitto";

export const inscricaoRealizada = () => {
  return {
    type: "INSCRICAO_REALIZADA",
    resposta: true,
  };
};
